<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('columns.shipOnly') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addNewOrderButton="true"
          :permissions="{
            add_permission: 'add_ship_only',
            approve_all_permission: 'approve_ship_only',
            approve_all_shiponly: 'approve_all_shiponly'
          }"
          :openAddNewOrderModal="openAddNewOrderModal"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :checkAlert="checkAlert"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :showApproveAllShiponly="showApproveAllShiponly"
          :loadApproveAllShiponly="loadApproveAllShiponly"
          :approvingMultipleOrder="approvingMultipleOrder"
          @branch-edit="branchEdit"
        />

        <div class="col-xs-12">
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.user_id }}</td>
                <td class="ws-nowrap">
                    <customer-device-icon :orderSource="r.order_source" />
                    <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >
                    {{ r.product_url ?  r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) + (r.product_url.length > 10 ? '...' : '') : r.product_url }}
                  </a>
                </td>
                <td>{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '' }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.track_number }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  class="rtl-pl-10 rtl-pr-5"
                >
                  <a
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('edit_ship_only')"
                  style="padding-left:10px; padding-right:10px"
                >
                  <a
                    @click="editOrder(r)"
                    style="color: #424242"
                    :tooltip="$t('orders.editThisOrderTooltip')"
                  ><i class="material-icons">settings</i></a>
                </td>
                <td
                  v-if="$_has_perm('cancel_ship_only')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    @click="openCancelingOrderModal(r.order_id)"
                    style="color:#C62828"
                    :tooltip="$t('orders.cancelThisOrder')"
                  ><i class="material-icons">cancel</i></a>
                </td>
                <td
                  v-if="r.track_number && r.from_date && $_has_perm('approve_ship_only')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    @click="approvingOrder(r)"
                    style="color: #43a047"
                    :tooltip="$t('orders.approveThisOrderTooltip')"
                  ><i class="material-icons">check_circle</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.theOrderID }} , <br />
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url ? r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '') : r.product_url
                  }}</a>
                  <br />
                  {{ $t('columns.quantity') }}: {{ r.quantity }}
                </td>
                <td>
                  {{ $t('columns.customerId') }}: {{ r.user_id }} , <br />
                  {{ $t('columns.name') }}: {{ r.full_name }} <open-whatsapp-and-viber :phoneNumber="r.phone_number" /> , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block" class="rtl-pl-5"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <a
                    v-if="$_has_perm('edit_ship_only')"
                    @click="editOrder(r)"
                    style="color: #4347a0" class="rtl-pl-15"
                    :tooltip="$t('orders.editThisOrderTooltip')"
                  ><i class="material-icons">settings</i></a>
                  <a
                    v-if="r.track_number && r.from_date && $_has_perm('approve_ship_only')"
                    @click="approvingOrder(r)"
                    style="color: #43a047" class="rtl-pl-15"
                    :tooltip="$t('orders.approveThisOrderTooltip')"
                  ><i class="material-icons">check_circle</i></a>
                  <a
                    v-if="$_has_perm('cancel_ship_only')"
                    @click="openCancelingOrderModal(r.order_id)"
                    style="color:#C62828" class="rtl-pl-3 rtl-float-left"
                    :tooltip="$t('orders.cancelThisOrder')"
                  ><i class="material-icons">cancel</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <add-ship-only
            :addShipOnlyModal="addShipOnlyModal"
            :warehouses="warehouses"
            @close="addShipOnlyModal = false"
            @resetTable="handleResetTable"
            :customers="customers"
            :isUpdate="isUpdate"
            :formData="formData"
          />

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          />

          <view-log-details
            :detialData="detialData"
            :closeModal="closeModal"
            :companyData="companyData"
            :exRate="exRate"
          />

          <!-- Approve -->
          <v-dialog
            v-model="approvingDialog"
            :overlay="false"
            max-width="500px"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title
                primary-title
                class="pb-2 pt-3"
              >
                <h3 class="my-0">{{ $t('common.areYouSure') }}</h3>
              </v-card-title>
              <v-card-text>
                <v-layout
                  row
                  wrap
                  class="mx-2"
                >
                  <v-flex xs12>
                    <h6>{{ $t('columns.customer') }}: {{ orderData.full_name }}</h6>
                  </v-flex>
                  <v-flex xs12>
                    <h6>{{ $t('columns.balance') }}: ${{ orderData.credit }}</h6>
                  </v-flex>
                  <v-flex xs12>
                    <h6>{{ $t('shipOnly.orderPriceLabel') }}: ${{ orderData.total_amount }}</h6>
                  </v-flex>

                  <!-- <v-flex xs12>
                    <branch-select
                      label="Approve branch *"
                      v-model="orderData.branch_id_fk"
                    />
                  </v-flex> -->

                  <!-- <v-flex xs12>
                    <branch-select
                      label="Deliver branch *"
                      v-model="orderData.deliver_branch_id_fk"
                    /> -->
                  </v-flex>

                  <v-flex xs12>
                    <v-radio-group v-model="approveValue">
                      <v-radio
                        :label="$t('shipOnly.willPayOption')"
                        value="1"
                      />
                      <v-radio
                        :label="$t('shipOnly.loanOption')"
                        value="2"
                        :disabled="orderData.credit >= orderData.total_amount && orderData.total_amount !== 0"
                      />
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    xs12
                    v-show="approveValue === '1'"
                  >
                    <a
                      href="/secret?component=credit"
                      target="blank"
                      style="font-size: 14px; text-decoration: underline"
                    >
                      {{ $t('shipOnly.goToCustomerCreditLink') }}
                    </a>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  style="height: auto"
                  @click="approvingDialog = false"
                  outline
                  color="normal"
                >{{ $t('common.close') }}</v-btn>
                <v-btn
                  :disabled="!orderData.total_amount && orderData.total_amount !== 0"
                  style="height: auto" class="rtl-mr-1-5pct"
                  outline
                  color="success"
                  @click="approveOrder"
                  :loading="loadSingleApprove"
                >ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <admin-cancel-order
            :closeCancelingOrderModal="closeCancelingOrderModal"
            :cancelOrderModal="cancelOrderModal"
            :cancelAlert="cancelAlert"
            :cancelData="cancelData"
            :cancelingOrder="cancelingOrder"
            @reset-form="resetCancelData"
            :reasons="reasons"
          ></admin-cancel-order>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import mobileDatatable from './mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import addShipOnly from './addShipOnly.vue'
import viewLogDetails from './logs/viewLogDetails.vue'
import adminCancelOrder from './adminCancelOrder'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    addShipOnly,
    'mobile-datatable': mobileDatatable,
    'view-log-details': viewLogDetails,
    'admin-cancel-order': adminCancelOrder
  },

  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?order=', '') !== null ||
        window.location.search.replace('?order=', '') !== ''
      ) {
        let value = window.location.search.replace('?order=', '')
        this.searchOneCol('order_id', value)
      }
    }
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()
    this.getItemType()
    this.getWarehouses()
    this.getReasons()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  watch: {
    $route() {
      if (this.queryParameter === true) {
        if (
          window.location.search.replace('?order=', '') !== null ||
          window.location.search.replace('?order=', '') !== ''
        ) {
          let value = window.location.search.replace('?order=', '')
          this.searchOneCol('order_id', value)
        }
      }
    },
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      // {
      //   label: 'Branches',
      //   text: 'Branches',
      //   value: '2',
      //   sortable: false,
      //   searchable: false,
      //   name: 'branches'
      // },
      {
        label: this.$t('common.user'),
        text: this.$t('common.user'),
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: this.$t('columns.orderId'),
        text: this.$t('columns.orderId'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: this.$t('columns.customerId'),
        text: this.$t('columns.customerId'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'user_id'
      },
      {
        label: this.$t('columns.customerName'),
        text: this.$t('columns.customerName'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: this.$t('columns.customerNote'),
        text: this.$t('columns.customerNote'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: this.$t('columns.productUrl'),
        text: this.$t('columns.productUrl'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: this.$t('columns.productName'),
        text: this.$t('columns.productName'),
        value: '8',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: this.$t('columns.qty'),
        text: this.$t('columns.qty'),
        value: '9',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: this.$t('columns.warehouse'),
        text: this.$t('columns.warehouse'),
        value: '10',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: this.$t('columns.type'),
        text: this.$t('columns.type'),
        value: '11',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj'
      },
      {
        label: this.$t('columns.trackNumber'),
        text: this.$t('columns.trackNumber'),
        value: '12',
        sortable: true,
        searchable: true,
        name: 'track_number'
      },
      {
        label: this.$t('columns.note'),
        text: this.$t('columns.note'),
        value: '13',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: this.$t('common.date'),
        text: this.$t('common.date'),
        value: '14',
        sortable: true,
        searchable: true,
        name: 'order_date'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      approveValue: '1',
      loadSingleApprove: false,
      isMobile: false,
      loader: null,
      loading: false,
      isUpdate: false,
      approvingDialog: false,
      checkAlert: false,
      formData: {},
      showApproveAllShiponly: true,
      approvingMultipleOrder: false,
      url: 'api/get_ship_only_orders',
      approvingOrderUrl: 'api/approving_order_by_admin',
      orderDetailUrl: 'api/show_order_detail',
      getCustomerUrl: 'api/get-customer-to-select',
      getItemTypeUrl: 'api/get-item-type',
      logDetailUrl: 'api/credit_log_transactions',
      purchaseOrderUrl: 'api/purchasing_order',
      companyUrl: 'api/company_info',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      alertValue: false,
      addShipOnlyModal: false,
      companyData: {},
      exRate: 1,
      warehouses: [],
      reasons: [],
      customers: [],
      itemTypeResult: [],
      itemTypes: [],
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      customersResult: [],
      cancelData: {
        cancel_reason: '',
        cancel_reason_ar: '',
        cancel_reason_ku: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      orderData: {},
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    handleResetTable(order) {
      this.getResults()
      this.initDetail('modal_showApp', order.order_id)
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    editOrder(row) {
      this.formData = { ...row }
      this.isUpdate = true
      this.addShipOnlyModal = true
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types, estimate_days: r.estimate_days })
          })
        })
    },

    getReasons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data
          result.forEach((r) => {
            this.reasons.push({
              text: r.cancel_reason,
              value: r.cancel_reason,
              ar: r.cancel_reason_ar,
              ku: r.cancel_reason_ku
            })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true
      this.theCancelOrderID = orderId
    },

    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelData.cancel_reason = ''
      this.cancelData.cancel_reason_ar = ''
      this.cancelData.cancel_reason_ku = ''
    },

    resetCancelData() {
      this.cancelData.cancel_reason = ''
      this.cancelData.cancel_reason_ar = ''
      this.cancelData.cancel_reason_ku = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put('api/canceling_order_by_admin/' + this.theCancelOrderID, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getResults()
          this.cancelAlert = true
          let self = this
          setTimeout(() => {
            self.closeCancelingOrderModal()
          }, 1500)
        })
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData.company_name = response.data.data.company_name
          this.companyData.company_address = response.data.data.company_address
          this.companyData.company_email = response.data.data.company_email
        })
    },

    initInvoice(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => { this.exRate = res.data ? res.data.ex_rate || 1 : 1 })
        .catch(() => {})

      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    approveOrder() {
      this.loadSingleApprove = true
      let token = localStorage.getItem('access_token')
      axios.post(this.approvingOrderUrl, this.orderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.loadSingleApprove = false
        this.creditLogResponse = response.data.message
        this.getResults()
        this.approvingDialog = false

        // Purchase the order immediately after approving it
        // axios
        //   .put(this.purchaseOrderUrl + '/' + this.orderData.order_id, '', {
        //     headers: { Authorization: 'Bearer ' + token }
        //   })
        //   .then(() => {
        //     this.orderData = {}
        //     swal({
        //       title: '',
        //       text: 'Do you want to see this order invoice ?',
        //       icon: 'warning',
        //       buttons: true
        //     }).then((confirm) => {
        //       if (confirm) {
        //         this.initInvoice(
        //           'modal_showAppLog',
        //           this.creditLogResponse.credit_log_transaction_id
        //         )
        //       }
        //     })
        //   })
      })
        .catch((error) => {
          this.loadSingleApprove = false
          swal(this.$t('common.error'), error.response.data.message, 'error')
        })
    },

    loadApproveAllShiponly() {
      this.approvingMultipleOrder = true
      let token = localStorage.getItem('access_token')

      axios.post(this.approvingOrderUrl, { orders: this.qrCodeValues }, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(() => {
        // Purchase after approve for each order
        // let purchasePromises = this.qrCodeValues.map(orderId => {
        //   return axios.put(this.purchaseOrderUrl + '/' + orderId, '', {
        //     headers: { Authorization: 'Bearer ' + token }
        //   })
        // })

        // return Promise.all(purchasePromises)
      }).then(() => {
        this.approvingMultipleOrder = false
        this.qrCodeValues = []
        this.getResults()
        swal(this.$t('common.success'), this.$t('shipOnly.allOrdersApprovedAndPurchased'), 'success')
      }).catch((error) => {
        this.approvingMultipleOrder = false
        swal(this.$t('common.error'), error.response.data.message, 'error')
      })
    },

    approvingOrder(data) {
      this.orderData = data
      this.approvingDialog = true
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()

      let a = this
      setTimeout(function () {
        a.queryParameter = true
      }, 1000)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    openAddNewOrderModal() {
      this.formData = {}
      this.isUpdate = false
      this.addShipOnlyModal = true
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customersResult = response.data.data
          this.customersResult.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + [c.phone_number, c.phone_number_2].filter(Boolean).join(' / '),
              value: c.user_id
            })
          })
        })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.itemTypeResult = response.data.data
          this.itemTypeResult.forEach((c) => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_name,
              shippingPrice: c.type_int_shipping_price
            })
          })
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shipOnly.vue